import axios from 'axios';

const log = require("loglevel").getLogger("UserService");
log.setLevel("error");

axios.interceptors.request.use(request => {
	log.info('Starting Request', request.url);
	return request;
});

axios.interceptors.response.use(response => {
	// console.log('Response:', response)
	return response;
});

export const loadMoreSimilarities = (vendor, value, pageNumber, amount) => {
	const data = {
		value,
		pageSize: amount,
		pageNumber
	};

	return axios.post(`${process.env.REACT_APP_HOST_URL}/${vendor}/match/similarities`, data)
		.then(async response => {
			const res = response.data;
			log.debug("UserService -> loadMoreSimilarities -> results: " + res.length);
			return res.data;
		})
		.catch(response => {
			log.debug("userService -> loadMoreSimilarities -> error: ");
			log.debug(response);
			return null;
		})
};

export const loadUserList = row => {
	return axios.post(`${process.env.REACT_APP_HOST_URL}/${row.vendor}/list/load`, { id: row.id })
		.then(async response => {
			const res = response.data;
			log.debug("UserService -> loadUserList -> return");
			return res;
		})
		.catch(response => {
			log.debug("userService -> loadUserList -> error: ");
			log.debug(response);
			return null;
		})
};

export const deleteUserList = id => {
	return axios.post(`${process.env.REACT_APP_HOST_URL}/common/lists/remove`, { id })
		.then(async response => {
			const res = response.data;
			log.debug("UserService -> deleteUserList -> result: " + res.data);
			return res.data;
		})
		.catch(response => {
			log.debug("userService -> deleteUserList -> error: ");
			log.debug(response);
			return null;
		})
};

export const runReport = (vendor, data) => {
	return axios.post(`${process.env.REACT_APP_HOST_URL}/${vendor}/report/run`, {data})
		.then(async response => {
			const res = response.data;
			log.debug("UserService -> runReport -> result: " + res.data);
			return res;
		})
		.catch(response => {
			log.debug("userService -> runReport -> error: ");
			log.debug(response);
			return null;
		})
};

export const ping = () => {
	return axios.get(`${process.env.REACT_APP_HOST_URL}/general/ping`);
};

export const updateSavedListExcludedRows = (listId, excludedAccounts) => {
	const data = {
		listId,
		excludedAccounts: excludedAccounts.join("|")
	};

	return axios.post(`${process.env.REACT_APP_HOST_URL}/common/list/update/excluded`, data);
};

export const extractOpportunities = () => {
	return axios.get(`${process.env.REACT_APP_HOST_URL}/general/extractOpportunities`)
		.then(async response => {
			const res = response.data;
			return res.data;
		})
		.catch(response => {
			log.debug("userService -> extractOpportunities -> error: ");
			log.debug(response);
			return null;
		})
};

export const getAllUserLists = () => {
	return axios.get(`${process.env.REACT_APP_HOST_URL}/common/lists/get`)
		.then(async response => {
			const res = response.data;
			log.debug("UserService -> getAllUserLists -> results: " + res.data.length);
			return res.data;
		})
		.catch(response => {
			log.debug("userService -> getAllUserLists -> error: ");
			log.debug(response);
			return null;
		})
};

export const saveList = (name, description, accountNames, excludedAccounts, fileName, vendor) => {
	const data = {
		name,
		description,
		accountNames: JSON.stringify(accountNames),
		excludedAccounts,
		fileName,
		vendor
	};

	return axios.post(`${process.env.REACT_APP_HOST_URL}/common/lists/save`, data)
		.then(async response => {
			const res = response.data;
			log.debug("UserService -> saveList -> results: " + res);
			return res.data;
		})
		.catch(response => {
			log.debug("userService -> saveList -> error: ");
			log.debug(response);
			return null;
		})
};

export const loadSuggestions = (vendor, regions, segments, value) => {
	return axios.post(`${process.env.REACT_APP_HOST_URL}/${vendor}/search/single`, {value, regions, segments})
		.then(async response => {
			const res = response.data;
			log.debug("UserService -> loadSuggestions -> results: " + res.length);
			return res;
		})
		.catch(response => {
			log.debug("userService -> loadSuggestions -> error: ");
			log.debug(response);
			return null;
		})
};

export const saveUserMatch = (inputName, matchedName, vendor) => {
	const data = {
		inputName,
		matchedName,
		vendor
	};

	return axios.post(`${process.env.REACT_APP_HOST_URL}/common/match/save`, data)
		.then(async response => {
			const res = response.data;
			log.debug("UserService -> saveUserMatch -> result: " + res);
			return res;
		})
		.catch(response => {
			log.debug("userService -> saveUserMatch -> error: ");
			log.debug(response);
			return null;
		})
};

export const unsaveUserMatch = (inputName, matchedName, vendor) => {
	const data = {
		inputName,
		matchedName,
		vendor
	};

	return axios.post(`${process.env.REACT_APP_HOST_URL}/common/match/unsaveMatch`, data)
		.then(async response => {
			const res = response.data;
			log.debug("UserService -> unsaveMatch -> result: " + res);
			return res;
		})
		.catch(response => {
			log.debug("userService -> unsaveMatch -> error: ");
			log.debug(response);
			return null;
		})
};

export const updateSavedListAccounts = (listId, accounts) => {
	const data = {
		listId,
		accounts: JSON.stringify(accounts)
	};

	return axios.post(`${process.env.REACT_APP_HOST_URL}/common/list/update/accounts`, data);
};

export const getVendorAccounts = (vendor,  limit, offset, selectedFilters) => {
	return axios.post(`${process.env.REACT_APP_HOST_URL}/${vendor}/get`, {limit, offset, selectedFilters})
		.then(async response => {
			const accounts = response.data.data;
			const total = response.data.total;
			return {accounts, total};
		})
		.catch(response => {
			log.debug("userService -> getVendorAccounts -> error: ");
			return null;
		})
};

export const createExternalUser = (user) => {
	return axios.post(`${process.env.REACT_APP_HOST_URL}/user/create/external`, {user})
		.then(async response => {
			const res = response.data;
			return res;
		})
		.catch(response => {
			log.debug("userService -> createExternalUser -> error: ");
			return null;
		})
};

export const createInternalUser = (email, name, account) => {
	return axios.post(`${process.env.REACT_APP_HOST_URL}/user/create/internal`, {email, name, account})
		.then(async response => {
			const res = response.data;
			return res;
		})
		.catch(response => {
			log.debug("userService -> createInternalUser -> error: ");
			return null;
		})
};

export const loadContacts = (accountName) => {
	return axios.post(`${process.env.REACT_APP_HOST_URL}/user/account/contacts`, {accountName})
		.then(async response => {
			const res = response.data.users;
			log.debug("UserService -> registerUser -> response: " + JSON.stringify(res));
			return res;
		})
		.catch(response => {
			log.debug("userService -> registerUser -> error: ");
			return null;
		})
};

export const registerUser = (email, uid) => {
	return axios.post(`${process.env.REACT_APP_HOST_URL}/user/register`, {email, uid})
		.then(async response => {
			const res = response.data.user;
			log.debug("UserService -> registerUser -> response: " + JSON.stringify(res));
			return res;
		})
		.catch(response => {
			log.debug("userService -> registerUser -> error: ");
			return null;
		})
};

export const checkInvite = hash => {
	return axios.get(`${process.env.REACT_APP_HOST_URL}/user/invite/${hash}`)
		.then(async response => {
			const res = response.data.user;
			log.debug("UserService -> checkInvite -> response: " + JSON.stringify(res));
			return res;
		})
		.catch(response => {
			log.debug("userService -> checkInvite -> error: ");
			return null;
		})

};

export const toggleUserEnabled = email => {
	return axios.post(`${process.env.REACT_APP_HOST_URL}/user/enabled/toggle`, {email})
		.then(async response => {
			return response.data.status;
		})
		.catch(response => {
			log.debug("userService -> searchResults -> error: ");
			log.debug(response);
			return null;
		})
};

export const searchResults = (searchTerm, searchOption) => {
	return axios.post(`${process.env.REACT_APP_HOST_URL}/user/search`, {searchTerm, searchOption})
		.then(async response => {
			const results = response.data.results;
			log.debug(`UserService -> searchResults -> found ${results.length} results.`);
			return results;
		})
		.catch(response => {
			log.debug("userService -> searchResults -> error: ");
			log.debug(response);
			return null;
		})
};

export const loadUsers = () => {
	return axios.get(`${process.env.REACT_APP_HOST_URL}/user/get`)
		.then(async response => {
			const res = response.data.results;
			log.debug("UserService -> loadUsers -> response: " + JSON.stringify(res));
			return res;
		})
		.catch(response => {
			log.debug("userService -> loadUsers -> error: ");
			log.debug(response);
			return null;
		})
};

export const changeUserDatabase = (email, database) => {
	const data = {
		email,
		database
	};

	return axios.post(`${process.env.REACT_APP_HOST_URL}/user/changedb`, data)
		.then(async response => {
			const res = response.data;
			return res;
		})
		.catch(response => {
			log.debug("userService -> changeUserDatabase -> error: ");
			log.debug(response);
			return null;
		})
};

export const switchAccount = (account) => {
	const data = {
		account
	};

	return axios.post(`${process.env.REACT_APP_HOST_URL}/user/switchaccount`, data)
		.then(async response => {
			const res = response.data.user;
			log.debug("UserService -> switchAccount -> response: " + JSON.stringify(res));
			return res;
		})
		.catch(response => {
			log.debug("userService -> switchAccount -> error: ");
			log.debug(response);
			return null;
		})
};

export const searchAccounts = async (vendor, accountNames, regions, segments) => {
	const data = {
		values: accountNames,
		regions,
		segments
	};

	return axios.post(`${process.env.REACT_APP_HOST_URL}/${vendor}/search/list`, data)
		.then(async response => {
			const res = response.data;
			log.debug("UserService -> searchAccounts -> results: " + res.length);
			return res;
		})
		.catch(data => {
			log.debug("userService -> searchAccounts -> error: ");
			log.debug(data);
			return null;
		})
};

export const signIn = async idToken => {
	return axios.post(`${process.env.REACT_APP_HOST_URL}/user/login`, {idToken})
		.then(async response => {
			const res = response.data.user;
			log.debug("UserService -> signIn -> response: " + JSON.stringify(res));
			return res;
		})
		.catch(response => {
			log.debug("userService -> signIn -> error: ");
			log.debug(response);
			return null;
		})
};

export const signOut = async () => {
	return axios.get(`${process.env.REACT_APP_HOST_URL}/user/logout`)
		.then(async response => {
			const res = response.data;
			log.debug("UserService -> signOut service -> response: " + JSON.stringify(res));
			return res;
		})
		.catch(response => {
			log.debug("userService -> signOut -> error: ");
			log.debug(response);
			return null;
		})
};

export const requestDownload = async (records) => {
	return axios.post(`${process.env.REACT_APP_HOST_URL}/user/download/request`, { records })
		.then(async response => {
			const res = response.data;
			log.debug("UserService -> requestDownload service -> response: " + JSON.stringify(res));
			return res;
		})
		.catch(response => {
			log.debug("userService -> requestDownload -> error: ");
			log.debug(response);
			return null;
		})
};
